import { Analytics } from '@vercel/analytics/next'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { redactUrlSecrets } from 'lib/helpers/redactUrlSecrets/redactUrlSecrets'

const redactEventUrl = <T extends { url: string }>(event: T): T => ({
  ...event,
  url: redactUrlSecrets({ url: event.url }),
})

export const VercelAnalytics = () => {
  const isVercelDeployment = process.env.VERCEL_ENV === 'production'

  if (!isVercelDeployment) {
    return null
  }

  return (
    <>
      <Analytics beforeSend={redactEventUrl} />
      <SpeedInsights beforeSend={redactEventUrl} />
    </>
  )
}
